import { eventBus } from '@/libs/eventBus';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { useEffect } from 'react';

// TT-260: version-one owns the Waqf Qard Hassan dashboard card but can't read
// GrowthBook (host-only SDK). Host reads enable-waqf and relays it over the
// single-spa bus. Emits on change, and re-emits on request so version-one gets
// the value whenever it (re)subscribes, regardless of when the flag resolves.
// Renders nothing. Same shape as WakalaFlagRelay, deliberately: a second flag
// with its own event pair rather than a shared one, so turning the Waqf on or
// off never moves the Wakala card.
export function WaqfFlagRelay() {
  const enabled = useFeatureValue('enable-waqf', false);

  useEffect(() => {
    eventBus.emit('mife:waqf-flag', { enabled });
    const onRequest = () => eventBus.emit('mife:waqf-flag', { enabled });
    eventBus.on('mife:request-waqf-flag', onRequest);
    return () => eventBus.off('mife:request-waqf-flag', onRequest);
  }, [enabled]);

  return null;
}
